"use strict";

var _regeneratorRuntime = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadImageAndCreateRemoteFileNode = void 0;

var format_message_1 = require("./format-message");
/**
 * Downloads an image and creates a remote file node in Gatsby's data layer.
 *
 * @export
 * @param {NodeInput} node
 * @param {NodePluginArgs} helpers
 * @param {string} prefix
 * @returns {Promise<NodeInput>}
 */


function downloadImageAndCreateRemoteFileNode(_x, _x2, _x3, _x4) {
  return _downloadImageAndCreateRemoteFileNode.apply(this, arguments);
}

function _downloadImageAndCreateRemoteFileNode() {
  _downloadImageAndCreateRemoteFileNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, helpers, createRemoteFileNode, prefix) {
    var _helpers$actions, createNode, touchNode, createNodeId, store, cache, reporter, imageDataCacheKey, cachedRemoteData, createAndCacheRemoteFileNode, message, asFormattedMessage;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _helpers$actions = helpers.actions, createNode = _helpers$actions.createNode, touchNode = _helpers$actions.touchNode, createNodeId = helpers.createNodeId, store = helpers.store, cache = helpers.cache, reporter = helpers.reporter;
            imageDataCacheKey = "".concat(prefix, "__IMAGE__").concat(node.src);
            _context2.next = 5;
            return cache.get(imageDataCacheKey);

          case 5:
            cachedRemoteData = _context2.sent;

            createAndCacheRemoteFileNode = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var fileNode, _yield$cache$set, fileNodeID;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return createRemoteFileNode({
                          cache: cache,
                          createNode: createNode,
                          createNodeId: createNodeId,
                          parentNodeId: node.id,
                          reporter: reporter,
                          store: store,
                          url: node.src
                        });

                      case 2:
                        fileNode = _context.sent;
                        _context.next = 5;
                        return cache.set(imageDataCacheKey, {
                          fileNodeID: fileNode.id
                        });

                      case 5:
                        _yield$cache$set = _context.sent;
                        fileNodeID = _yield$cache$set.fileNodeID;
                        // tslint:disable-next-line: no-expression-statement
                        node.localFile___NODE = fileNodeID;
                        return _context.abrupt("return", node);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function createAndCacheRemoteFileNode() {
                return _ref.apply(this, arguments);
              };
            }();

            if (!cachedRemoteData) {
              _context2.next = 11;
              break;
            }

            _context2.t0 = touchNode(cachedRemoteData);
            _context2.next = 14;
            break;

          case 11:
            _context2.next = 13;
            return createAndCacheRemoteFileNode();

          case 13:
            _context2.t0 = _context2.sent;

          case 14:
            return _context2.abrupt("return", _context2.t0);

          case 17:
            _context2.prev = 17;
            _context2.t1 = _context2["catch"](0);
            message = "Error downloading image and creating remote file node: ".concat(_context2.t1);
            asFormattedMessage = format_message_1.formatMessage();
            console.log(asFormattedMessage(message, 'red'));
            console.log("node:\n".concat(node));
            return _context2.abrupt("return");

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 17]]);
  }));
  return _downloadImageAndCreateRemoteFileNode.apply(this, arguments);
}

exports.downloadImageAndCreateRemoteFileNode = downloadImageAndCreateRemoteFileNode;